import React from 'react';

const RoughDetailModal = ({ show, onClose, lot }) => {
    if (!show || !lot) return null;

    return (
        <div className="modal d-block" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}>
            <div className="modal-dialog modal-lg">
                <div className="modal-content">
                    
                    {/* HEADER */}
                    <div className="modal-header bg-dark text-white">
                        <h5 className="modal-title">Lot Details: <span className="text-warning">{lot.rpNumber}</span></h5>
                        <button type="button" className="btn-close btn-close-white" onClick={onClose}></button>
                    </div>

                    {/* BODY */}
                    <div className="modal-body">
                        {/* 1. INFO ROW */}
                        <div className="row mb-4 border-bottom pb-3">
                            <div className="col-md-4">
                                <small className="text-muted d-block">Party (Seller)</small>
                                <strong>{lot.party?.companyName}</strong>
                                <div className="small text-muted">{lot.party?.name}</div>
                            </div>
                            <div className="col-md-4">
                                <small className="text-muted d-block">Broker</small>
                                <strong>{lot.broker?.name || '-'}</strong>
                            </div>
                            <div className="col-md-4 text-end">
                                <span className={`badge ${lot.billType === 'Cash' ? 'bg-success' : 'bg-primary'} mb-1`}>
                                    {lot.billType}
                                </span>
                                <div className="small text-muted">
                                    Date: {new Date(lot.purchaseDate).toLocaleDateString('en-GB')}
                                </div>
                            </div>
                        </div>

                        {/* 2. MATH BREAKDOWN TABLE */}
                        <h6 className="text-primary fw-bold">Financial Breakdown</h6>
                        <table className="table table-bordered table-sm">
                            <thead className="table-light">
                                <tr>
                                    <th>Description</th>
                                    <th className="text-center">Calculation</th>
                                    <th className="text-end">Amount ({lot.currency})</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>Base Value</td>
                                    <td className="text-center text-muted">{lot.weight} Cts × {lot.rate}</td>
                                    <td className="text-end">{lot.baseAmount.toFixed(2)}</td>
                                </tr>
                                <tr>
                                    <td>Discount</td>
                                    <td className="text-center text-danger">-{lot.discountPercent}%</td>
                                    <td className="text-end text-danger">-{lot.discountAmount.toFixed(2)}</td>
                                </tr>
                                <tr className="fw-bold bg-light">
                                    <td>Net Amount</td>
                                    <td className="text-center">-</td>
                                    <td className="text-end">{lot.netAmount.toFixed(2)}</td>
                                </tr>
                                
                                {/* Tax Section */}
                                {lot.billType === 'Bill' && (
                                    <>
                                        <tr>
                                            <td>GST (+)</td>
                                            <td className="text-center">{lot.gstPercent}%</td>
                                            <td className="text-end">{lot.gstAmount.toFixed(2)}</td>
                                        </tr>
                                        <tr>
                                            <td>TDS (Deducted)</td>
                                            <td className="text-center text-danger">-{lot.tdsPercent}%</td>
                                            <td className="text-end text-danger">({lot.tdsAmount.toFixed(2)})</td>
                                        </tr>
                                    </>
                                )}
                                
                                <tr>
                                    <td>Other Expenses</td>
                                    <td className="text-center">-</td>
                                    <td className="text-end">{lot.otherExpenses || 0}</td>
                                </tr>

                                {/* FINAL TOTALS */}
                                <tr className="table-success fw-bold" style={{borderTop:'2px solid #000'}}>
                                    <td>PARTY PAYABLE</td>
                                    <td className="text-center small text-muted">(Net + GST - TDS + Other)</td>
                                    <td className="text-end" style={{fontSize:'1.1rem'}}>{lot.partyPayable.toFixed(2)}</td>
                                </tr>
                            </tbody>
                        </table>

                        {/* 3. COSTING ROW */}
                        <div className="alert alert-secondary mt-3">
                            <div className="row text-center">
                                <div className="col-6 border-end">
                                    <small>Brokerage Payable</small>
                                    <h5 className="mb-0">{lot.brokerageAmount.toFixed(2)}</h5>
                                </div>
                                <div className="col-6">
                                    <small>Final Landed Cost (Your Cost)</small>
                                    <h5 className="mb-0 text-primary">{lot.landedCost.toFixed(2)}</h5>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="modal-footer">
                        <button type="button" className="btn btn-secondary" onClick={onClose}>Close</button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default RoughDetailModal;